/**
 * What the shell shows instead of the product when the API says 401.
 *
 * It is a link, not a form. The form is the API's own sign-in page (`/v1/sso/signin`, server-
 * rendered in routes/sso.ts), which already knows how to discover a tenant's SAML IdP from the
 * email domain, offer the upstream IdP when one is configured, hold the lockout and write the audit
 * rows. A second form here would be a second sign-in path with its own, weaker, rules. The page
 * comes back to `next` — the route the person was trying to open — through the API's `safeNext`,
 * so a deep link survives the round trip and a hostile `next` does not.
 *
 * The refusal's own words are kept on screen. "Not authenticated" with the API's hint is the
 * difference between a person who knows to ask for a login and one who files a bug.
 */

import { useLocation } from "react-router-dom";

export function SignIn({ reason, hint }: { reason?: string; hint?: string }) {
  const { pathname, search } = useLocation();
  const next = `${pathname}${search}`;
  return (
    <div className="signin" data-testid="signin">
      <div className="card">
        <div className="brand">Security Package Hub</div>
        <h1>Sign in</h1>
        <p className="sub">
          This hub governs people and agents as peers, and it will not show either to a visitor it
          cannot name. Sign in with your hub login, or through your organisation&apos;s identity
          provider where one is configured.
        </p>
        {reason && (
          <p className="muted" data-testid="signin-reason" style={{ fontSize: 13 }}>
            {reason}{hint ? ` ${hint}` : ""}
          </p>
        )}
        <a className="btn primary" data-testid="signin-link" href={`/v1/sso/signin?next=${encodeURIComponent(next)}`}>
          Sign in to the hub
        </a>
      </div>
    </div>
  );
}
